import { NextArrow, Play1 } from 'components/Common/Icon'
import gsap from 'gsap'
import { FC, useEffect } from 'react'

const Cursor: FC = () => {
  const AnimationCursor = () => {
    const cursorArrowArea = document.querySelectorAll('.cursorArrowArea')
    const cursorPlayArea = document.querySelectorAll('.cursorPlayArea')
    const moveCircle = (e) => {
      gsap.to('.cursorDot', {
        css: {
          left: e.clientX,
          top: e.clientY,
          transform: 'translate(-50%, -50%) scale(0.75)',
        },
      })
    }
    // Event Listeners
    document.addEventListener('mousemove', moveCircle)
    // default cursor
    document.addEventListener('mouseover', () => {
      gsap.to('.cursorDot', {
        scale: 1,
        autoAlpha: 1,
        ease: 'Expo.easeOut',
      })
    })

    // perticuler div over cursorArrow
    cursorArrowArea.forEach(function (el) {
      el.addEventListener('mouseover', (e) => {
        gsap.to('.cursorArrow', {
          display: 'block',
        })
        gsap.to('.cursorArrow', {
          scale: 1,
          autoAlpha: 1,
          ease: 'Expo.easeOut',
        })
        gsap.to('.cursorDot', {
          width: 100,
          height: 100,
          ease: 'Expo.easeOut',
        })
      })
      el.addEventListener('mouseout', (e) => {
        gsap.to('.cursorArrow', {
          display: 'none',
        })
        gsap.to('.cursorArrow', {
          scale: 0,
          autoAlpha: 0,
          ease: 'Expo.easeOut',
        })
        gsap.to('.cursorDot', {
          width: 20,
          height: 20,
          ease: 'Expo.easeOut',
        })
      })
      el.addEventListener('click', (e) => {
        gsap.to('.cursorArrow', {
          display: 'none',
        })
        gsap.to('.cursorArrow', {
          scale: 0,
          autoAlpha: 0,
          ease: 'Expo.easeOut',
        })
        gsap.to('.cursorDot', {
          width: 20,
          height: 20,
          ease: 'Expo.easeOut',
        })
      })
    })
    // perticuler div over cursorPlay
    cursorPlayArea.forEach(function (el) {
      el.addEventListener('mouseover', (e) => {
        gsap.to('.cursorPlay', {
          display: 'block',
        })
        gsap.to('.cursorPlay', {
          scale: 1,
          autoAlpha: 1,
          ease: 'Expo.easeOut',
        })
        gsap.to('.cursorDot', {
          width: 100,
          height: 100,
          ease: 'Expo.easeOut',
        })
      })
      el.addEventListener('mouseout', (e) => {
        gsap.to('.cursorPlay', {
          display: 'none',
        })
        gsap.to('.cursorPlay', {
          scale: 0,
          autoAlpha: 0,
          ease: 'Expo.easeOut',
        })
        gsap.to('.cursorDot', {
          width: 20,
          height: 20,
          ease: 'Expo.easeOut',
        })
      })
      el.addEventListener('click', (e) => {
        gsap.to('.cursorPlay', {
          display: 'none',
        })
        gsap.to('.cursorPlay', {
          scale: 0,
          autoAlpha: 0,
          ease: 'Expo.easeOut',
        })
        gsap.to('.cursorDot', {
          width: 20,
          height: 20,
          ease: 'Expo.easeOut',
        })
      })
    })
  }
  useEffect(() => {
    if (window.matchMedia('(min-width: 768px)').matches) {
      AnimationCursor()
    }
  })

  return (
    <div className="cursorDot">
      <div className="cursorArrow">
        <NextArrow />
      </div>
      <div className="cursorPlay">
        <Play1 />
      </div>
    </div>
  )
}
export default Cursor
